import Backbone from 'backbone'
import _ from 'underscore'
import SlideshowView from './slideshow-view'

class SlideshowsListView extends Backbone.View {
    initialize () {
        this.setElement('.c-slideshow')
        this.render()
    }

    render () {
        _.each(this.$el, (obj) => {
            new SlideshowView({
                el: obj
            })
        })
        // Checa todos os elementos que já estão na página
        // Core.Tasks.add(() => {
        //     Core.Lazyloading.checkAll()
        // })
    }
}

export default SlideshowsListView
